import { Redirect } from 'wouter'

export const NotFoundScreen = () => {
  return <Redirect to="/" />
}
